export default {
  apiKey: "AIzaSyC-sH0l6wdurnkU5QFjo2R1EP_q1_VElJg",
  authDomain: "mhm-kiosks.firebaseapp.com",
  projectId: "mhm-kiosks",
  storageBucket: "mhm-kiosks.appspot.com",
  messagingSenderId: "1052149278470",
  appId: "1:1052149278470:web:6b38fa3fb3d3cbf191a087",
};
